"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const scale = {
  "C": 130.75,
  "D": 146.75,
  "E": 164.75,
  "F": 174.5,
  "G": 196,
  "A": 220,
  "B": 247
};
var _default = exports.default = scale;